import { render, staticRenderFns } from "./IconBilletes.vue?vue&type=template&id=cb773dc6"
import script from "./IconBilletes.vue?vue&type=script&lang=js"
export * from "./IconBilletes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports